import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { modifyUrl } from 'utils/links/modify.util';
import logger from 'utils/logger.util';
import isTruthy from 'utils/predicates/isTruthy.util';
import clampOrMax from 'utils/values/clampOrMax.util';
import clampOrMin from 'utils/values/clampOrMin.util';

const L = logger('manipulation'); // eslint-disable-line no-unused-vars

const fromAnyToConsultationLink = (url) => {
  const u = fromAnyToString(url);
  // return fromAnyToString(url).replace(/(^\w+:|^)\/\//, '');

  // to avoid modifyUrl spamming warnings in the browser console, don't try it with an empty URL
  if (!u) return '';

  return modifyUrl({ url: u, delProtocol: true, delSlash: true });
};

const fromAnyToBookingLink = (url) => {
  const u = fromAnyToString(url);

  // to avoid modifyUrl spamming warnings in the browser console, don't try it with an empty URL
  if (!u) return '';

  return modifyUrl({ url: u, delProtocol: true, addParams: { utm: 'sms' } });
};

export const convertLink = (options) => {
  const { type, value } = options ?? {};

  if ('consultation' === type) return fromAnyToConsultationLink(value);
  if ('ncob' === type || 'booking' === type) return fromAnyToBookingLink(value);

  L.warn('convertLink()', 'Unknown type:', type);
  return '';
};

export const messageLinkInfo = (options) => {
  const { type, link: rawLink, text: rawText } = options ?? {};

  const link = convertLink({ type, value: rawLink });
  const isLinkProvided = isTruthy(rawLink);

  const text = fromAnyToString(rawText);
  const isInserted = !!(isLinkProvided && link && text.includes(link));

  return { link, text, rawLink, rawText, isLinkProvided, isInserted };
};

const insertText = (options) => {
  const array = [...fromAnyToString(options?.text)];
  const sep = fromAnyToString(options?.separator);

  array.splice(
    // if the beginning is invalid, add to the end
    clampOrMax(0, array.length, options?.bgn), // if there is a problem with the difference, use 0 as to not remove existing
    clampOrMin(0, array.length, options?.end - options?.bgn), // add separator around the segment
    sep + fromAnyToTrimmed(options?.segment) + sep,
  );

  return array.join(S.empty);
};

export const toggleMessageLink = (options) => {
  const { text: rawText, link: rawLink, type, bgn, end, separator } = options ?? {};

  const { link: segment, isLinkProvided, isInserted } = messageLinkInfo({ type, link: rawLink, text: rawText });

  const modified = isInserted
    ? fromAnyToString(rawText).replace(segment, S.empty)
    : insertText({
        text: rawText,
        segment,
        bgn,
        end,
        separator,
      });

  return { text: modified, rawText, rawLink, isLinkProvided, isInserted: !isInserted };
};
